import {request, serviceUrl} from "@/utils/request";

//获取告警日志 isDesc 是否倒序
export function listByRecordId(recordId, isDesc) {
  return request({
    method: 'post',
    url: serviceUrl.deviceService + '/alarm/log/listByRecordId',
    params: {recordId, isDesc}
  })
}

export function packageList(recordData, ticketNo) {
  let list = [];
  for (let item of recordData) {
    let params = {};
    switch (item.type) {
      case '告警产生':
        params = {
          content: item.type,
          timestamp: item.createTime,
          text: item.msg,
          color: '#299FFB'
        };
        break;
      case '告警处理':
        params = {
          content: item.type,
          timestamp: item.createTime,
          text: '处理人: ' + item.operator + " , 处理建议: " + (item.operationTxt ? item.operationTxt : '未填写任何内容'),
          color: '#299FFB'
        };
        break;
      case '告警消警':
        params = {
          content: item.type,
          timestamp: item.createTime,
          text: '处理人: ' + item.operator + " , 消警建议: " + (item.operationTxt ? item.operationTxt : '未填写任何内容'),
          color: '#299FFB'
        };
        break;
      case '告警恢复':
        params = {
          content: item.type,
          timestamp: item.createTime,
          text: item.msg,
          color: '#299FFB'
        };
        break;
      case '生成工单':
        params = {
          content: item.type,
          timestamp: item.createTime,
          text: '工单编号:' + ticketNo,
          color: '#299FFB'
        };
        break;
      default:
        params = {
          content: item.type,
          timestamp: item.createTime,
          text: item.msg,
          color: '#299FFB'
        };
    }
    list.push(params);
  }
  return list;
}
